import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { listDiscoverableAgents } from "@/lib/agents";
import { cachedPublicData } from "@/lib/public-cache";

export const fetchHomepageLeaderboard = createServerFn({
	method: "GET",
}).handler(async () => {
	return cachedPublicData("homepage-leaderboard", async () => {
		const agents = await listDiscoverableAgents({
			includeSnapshots: true,
			limit: 100,
		});
		return { agents };
	});
});

export type HomepageLeaderboardData = Awaited<
	ReturnType<typeof fetchHomepageLeaderboard>
>;

export const homepageLeaderboardQueryOptions = queryOptions({
	queryKey: ["public-agents", "leaderboard", "snapshots"] as const,
	queryFn: () => fetchHomepageLeaderboard(),
	staleTime: 60_000,
});
